import { gql } from '@apollo/client';

export const GET_ALL_LABELS = gql`
  query GetAllLabels {
    getAllLabels
  }
`;
